import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ChatLauncherComponent } from './components/chat-launcher/chat-launcher.component';
import { ChatPanelComponent } from './components/chat-panel/chat-panel.component';

/**
 * Agente conversacional de Sismat.
 *
 * Se declara en AppModule (no lazy) porque el chat vive en AppComponent y
 * tiene que sobrevivir a la navegación entre rutas.
 */
@NgModule({
  declarations: [
    ChatPanelComponent,
    ChatLauncherComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    ChatLauncherComponent,
  ],
})
export class ChatModule {}
